import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgLockerRounded = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 30 30"
    ref={ref}
    {...props}
  >
    <g filter="url(#locker-rounded_svg__a)">
      <circle cx={15} cy={15} r={12} fill="currentColor" />
    </g>
    <g clipPath="url(#locker-rounded_svg__b)">
      <path
        fill="#AEAEAE"
        d="M19.929 11.973h-1.99v-1.492a2.983 2.983 0 1 0-5.966 0v1.492h-1.99a.995.995 0 0 0-.994.995v6.961a.994.994 0 0 0 .995.995h9.945a.995.995 0 0 0 .994-.995v-6.961a.995.995 0 0 0-.994-.995m-4.476 4.887v1.577a.498.498 0 0 1-.994 0V16.86a1.492 1.492 0 1 1 .994 0m1.492-4.887h-3.978v-1.492a1.989 1.989 0 1 1 3.978 0z"
      />
    </g>
    <defs>
      <clipPath id="locker-rounded_svg__b">
        <path fill="currentColor" d="M7 7h16v16H7z" />
      </clipPath>
      <filter
        id="locker-rounded_svg__a"
        width={28.643}
        height={28.643}
        x={0.679}
        y={0.679}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.774} dy={-0.774} />
        <feGaussianBlur stdDeviation={0.774} />
        <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.5 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5020_26278"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.774} dy={0.774} />
        <feGaussianBlur stdDeviation={0.774} />
        <feColorMatrix values="0 0 0 0 0.258824 0 0 0 0 0.258824 0 0 0 0 0.258824 0 0 0 0.3 0" />
        <feBlend
          in2="effect1_dropShadow_5020_26278"
          result="effect2_dropShadow_5020_26278"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_5020_26278"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.774} dy={0.774} />
        <feGaussianBlur stdDeviation={1.161} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.9 0" />
        <feBlend in2="shape" result="effect3_innerShadow_5020_26278" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.774} dy={-0.774} />
        <feGaussianBlur stdDeviation={0.774} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.258824 0 0 0 0 0.258824 0 0 0 0 0.258824 0 0 0 0.9 0" />
        <feBlend
          in2="effect3_innerShadow_5020_26278"
          result="effect4_innerShadow_5020_26278"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.774} dy={-0.774} />
        <feGaussianBlur stdDeviation={0.774} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.2 0" />
        <feBlend
          in2="effect4_innerShadow_5020_26278"
          result="effect5_innerShadow_5020_26278"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-0.774} dy={0.774} />
        <feGaussianBlur stdDeviation={0.774} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.2 0" />
        <feBlend
          in2="effect5_innerShadow_5020_26278"
          result="effect6_innerShadow_5020_26278"
        />
      </filter>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgLockerRounded);
export default ForwardRef;
